import { Colors, Services, getPrice } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import formatTable from '@/components/format/table'
import preloader from '@/components/preloader'
import { billingsStatuses } from '@/components/services/billings/utils'
import priceCalculation from '@/components/services/sendings/outgoing/details/tabs/billings/priceCalculation'
import tag from '@/components/tag'

const baseClass = `${Services.sendings}-item__tabs-billings`

function renderPreloader(h) {
  return h(
    'div',
    {
      class: [
        'preloader__holder',
        'preloader__holder--absolute',
        `${baseClass}__preloader`
      ]
    },
    [ h(preloader) ]
  )
}
function renderAbsolutePreloader(h) {
  if (this.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}

function renderSource(h, { source }) {
  if (typeof source !== 'string' || source.length === 0) {
    return
  }

  const [ s, t ] = source.split('.')
  const type = t || s

  if (type) {
    return h(
      tag,
      {
        props: {
          label: this.getTranslate(`${Services.billings}.sources.${type}`),
          color: type
        }
      }
    )
  }
}
function renderStatus(h, { status }) {
  const statusData = billingsStatuses[status]
  if (status) {
    let statusLabel = status
    if (statusData) {
      statusLabel = this.getTranslate(`${Services.billings}.statuses.${status}`)
    }

    return h(
      tag,
      {
        props: {
          label: statusLabel,
          color: statusData?.color || Colors.grey
        }
      }
    )
  }
}
function renderPrice(h, { amount }) {
  const price = getPrice(amount)
  if (!price) {
    return
  }

  return h(
    tag,
    {
      props: {
        label: price,
        color: Colors.primary
      }
    }
  )
}
function renderItemHeader(h, item) {
  return h(
    'div',
    {
      class: `${baseClass}-item__header`
    },
    [
      renderSource.call(this, h, item),
      renderStatus.call(this, h, item),
      renderPrice.call(this, h, item)
    ].filter(Boolean)
  )
}
function renderItemBody(h, value) {
  const formatTableValue = this.getFormatTableValue(value)

  return h(
    'div',
    {
      class: `${baseClass}-item__body`
    },
    [
      h(
        formatTable,
        {
          props: {
            value: formatTableValue,
            service: Services.billings
          }
        }
      ),
      h(
        priceCalculation,
        {
          props: { value }
        }
      )
    ]
  )
}
function renderItem(h, item, itemIndex) {
  return h(
    'div',
    {
      class: `${baseClass}-item`,
      key: item?.id || `${item?.source || 'billing'}:${item?.status || 'unknown'}:${itemIndex}`
    },
    [
      renderItemHeader.call(this, h, item),
      renderItemBody.call(this, h, item)
    ]
  )
}
function renderItems(h) {
  return h(
    'div',
    {
      class: `${baseClass}-items`
    },
    [
      ...this.items.map((item, itemIndex) => {
        return renderItem.call(this, h, item, itemIndex)
      }),

      renderAbsolutePreloader.call(this, h)
    ]
  )
}
function renderBody(h) {
  if (Array.isArray(this.items) && this.items.length) {
    return renderItems.call(this, h)
  } else {
    switch (this.loading) {
      case true: {
        return renderPreloader.call(this, h)
      }

      case false:
      default: {
        return h(components.empty)
      }
    }
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: baseClass
    },
    [ renderBody.call(this, h) ]
  )
}
